"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.deprecatedLogger = deprecatedLogger;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _netUtils = require("@onviobr/net-utils");

var _constants = require("./constants");

function xhrLogger(logger) {
  var _context;

  var domainAllowList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (0, _netUtils.injectEvent)('load', function () {
    var headers = this.getAllResponseHeaders().toLowerCase();

    if ((0, _includes.default)(headers).call(headers, 'x-cobalt-endpoint-status: deprecated') || (0, _includes.default)(headers).call(headers, 'x-endpoint-status: deprecated')) {
      logger(this.responseURL);
    }
  }, (0, _concat.default)(_context = [_constants.currentDomainRegex, _constants.interceptorAllowedDomains]).call(_context, (0, _toConsumableArray2.default)(domainAllowList)));
}

function fetchDeprecated(headers) {
  return headers.get('x-cobalt-endpoint-status') === 'Deprecated' || headers.get('x-endpoint-status') === 'Deprecated';
}

function fetchLogger(logger) {
  var _context2;

  var domainAllowList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (0, _netUtils.addResolveInterceptor)(function (response) {
    if (fetchDeprecated(response.headers)) {
      logger(response.url);
    }
  }, (0, _concat.default)(_context2 = [_constants.currentDomainRegex, _constants.interceptorAllowedDomains]).call(_context2, (0, _toConsumableArray2.default)(domainAllowList)));
}

function deprecatedLogger() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$xhr = _ref.xhr,
      xhr = _ref$xhr === void 0 ? true : _ref$xhr,
      _ref$fetch = _ref.fetch,
      fetch = _ref$fetch === void 0 ? true : _ref$fetch,
      _ref$logger = _ref.logger,
      logger = _ref$logger === void 0 ? console.warn : _ref$logger;

  var domainAllowList = arguments.length > 1 ? arguments[1] : undefined;

  var loggerFn = function loggerFn(url) {
    return logger('[Endpoint Deprecation] The following endpoint is marked as deprecated, ' + "please update to a new and maintained version.".concat(url));
  };

  var removeXhr = xhr && xhrLogger(loggerFn, domainAllowList);
  var removeFetch = fetch && fetchLogger(loggerFn, domainAllowList);
  return function () {
    if (removeXhr) {
      removeXhr();
    }

    if (removeFetch) {
      removeFetch();
    }
  };
}
